import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(err) {
    const snackbar = this.injector.get(MatSnackBar);
    // console.log('Snackbar: ', snackbar);
    let message: string;
    if (typeof err === typeof 's') {
      message = err
    } else {
      message = err.message || 'Some Error Occured. Please Try Again Later'
    }
    console.log('Error: ', err);
    // snackbar.open(message, 'OK', { duration: 3000 });
    // console.error('GLOBAL ERROR HANDLER: ', err);
    // throw err;
  }

}
